export default __webpack_public_path__ + "static/media/209.ca167123.jpg";